module.exports = __webpack_public_path__ + "img/SV.bdca3d8d.svg";